import axios from "axios";

const API = process.env.REACT_APP_API_URL;

// Returns an array of city objects: { name, state, lat, lng }
// No in-memory cache — data is fetched fresh on each component mount so admin
// changes (add / edit / delete) are reflected without a browser refresh.
export const getCities = async () => {
  const res = await axios.get(`${API}/cities`);
  return res.data;
};
